import { useGetCurrentUser } from '../data/hooks';
import { roles } from './constants';

export default function useRolesCondition(fetchRolesCondition: boolean) {
  const { data } = useGetCurrentUser(fetchRolesCondition) as {
    data:
      | {
          roleName: string;
        }
      | undefined;
  };

  const roleName = data?.roleName as string;

  const controlRoomDisplay = [roles.itAdmin, roles.controlRoom].includes(
    roleName,
  );

  const onlyControlRoom = roleName === roles.controlRoom;

  const settingsDisplay = [roles.itAdmin, roles.superUser].includes(roleName);

  const settingsPlatformTabDisplay = [roles.itAdmin, roles.superUser].includes(
    roleName,
  );

  const settingsUserMangementTabDisplay = [
    roles.itAdmin,
    roles.superUser,
  ].includes(roleName);

  const userManagementCondition = roleName === roles.itAdmin;

  const eventLibraryCondition = [roles.itAdmin, roles.superUser].includes(
    roleName,
  );

  const weatherEventFormModalCondition = [
    roles.itAdmin,
    roles.superUser,
  ].includes(roleName);

  return {
    controlRoomDisplay,
    onlyControlRoom,
    settingsDisplay,
    settingsPlatformTabDisplay,
    settingsUserMangementTabDisplay,
    userManagementCondition,
    eventLibraryCondition,
    weatherEventFormModalCondition,
  };
}
